import React from 'react';
import '../App.css'
import Appointment from "./appointment/Appointment";
import {connect} from "react-redux";

const mapStateToProps = (state, ownProps) => ({
    ...state
});

class App extends React.Component {

    render() {

        return (
            <Appointment/>
        )

    }

}


export default connect(mapStateToProps)(App);
